import type {CopilotChatThread, CopilotSpaceId} from '@github-ui/copilot-chat-types'

export function copilotSpaceIdFromThread(thread?: CopilotChatThread | null): CopilotSpaceId | null {
  if (!thread || !thread.customCopilotID || !thread.customCopilotOwner) return null

  return {
    id: thread.customCopilotID,
    owner: thread.customCopilotOwner,
  }
}
